<template>
  <div id="normalapp">
    <div id="normalLoginRoot">
      <KeepAlive>
        <router-view></router-view>
      </KeepAlive>
    </div>
    <Loading v-if="$store.state.showLoading"/>
    <Toast v-if="$store.state.showToast"/>
  </div>
</template>

<script>

import Loading from "views/loading/Loading.vue";
import Toast from "views/Normal/Toast.vue";
import utils from '@/utils';
import { request } from '@/normal/network/request';
import getRequestParams from "@/signParams";

export default {
  data () {
     return {
     }
   },
  components:{
    Loading,
    Toast,
  },
  mounted:function(){ 
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)

    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.state.commonParameters;

    
    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] == 'true') {
      this.$store.commit("updateLoginPageSize");
      console.log("横屏");
      let scrrentWidth = storeCommomParams['screenWidth'];
      let screenHeight = storeCommomParams['screenHeight'];
      if (scrrentWidth && screenHeight) {
        let radio = parseInt(scrrentWidth) / parseInt(screenHeight);
        console.log(radio);
        // 小屏iphone, 375   667   比例是1.77 ，比1.8都小的直接把高度设置大一些
        if (radio < 1.8) {
          this.$store.commit("updateLoginPageSizeWithValue",{"screenHeight": "58vh"})
        }
      }
    }else{
      console.log("竖屏");
      let scrrentWidth = storeCommomParams['screenWidth'];
      let screenHeight = storeCommomParams['screenHeight'];
      if (scrrentWidth && screenHeight) {
        let radio = parseInt(screenHeight) / parseInt(scrrentWidth);
        console.log(radio);
        // 小屏iphone, 375   667   比例是1.77 ，比1.8都小的直接把高度设置大一些
        if (radio < 1.8) {
          this.$store.commit("updateLoginPageSizeWithValue",{"screenWidth": "85vw", "screenHeight": "32vh"})
        }
      }
    }


    let signParams = getRequestParams({},storeCommomParams);
    let protocolReq = request({
    url:this.urls.GET_PROTOCOL,
    params: {
      data: signParams
      },
    })
    let policyReq = request({
      url:this.urls.GET_POLICY,
      params: {
        data: signParams
      },
    })
    // 获取用户协议和隐私政策的url
    Promise.all([protocolReq, policyReq]).then(values => {
      this.$store.dispatch('networkUpdateProtocolAndPolicy', 
      {"protocol":{"title":values[0]['title'],"url":values[0]['url']},
      "policy":{"title":values[1]['title'],"url":values[1]['url']}}
      )
    })
    // 通知安卓端，H5已经准备好，可以发送需要数据过来了
    // this.sendToClient('sdkFinish?')
    
    // 是否是横屏,修改高度，方便滑動
    // if (storeCommomParams['landGame'] === 'true') {
    //   this.contentHeight = "85vh"
    // }
  }, 
  // mounted:function(){

  // },
  methods:{
    
  }
}
</script>

<style>
  body{
    padding-top: 0%;
    margin: 0%;
  }

  #normalLoginRoot{
    width: 100vw;
    height: 100vH;
    background-color: #0505056f;
    /* background-color:#99000000; */
    /* opacity: 0.2; */
  }
  input{
    outline: none;
  }

</style>



// WEBPACK FOOTER //
// src/views/Normal/NormalLogin.vue